import React, { Suspense } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import { useDataContext } from "../DataContext";
import {
  homePathForServiceType,
  isPathAllowedForServiceType,
  resolveVendorServiceType,
} from "../../utils/vendorServiceAccess";

const PageLoadingFallback = () => (
  <div
    className="d-flex align-items-center justify-content-center p-5"
    style={{ minHeight: "60vh" }}
  >
    <div className="text-center">
      <div
        className="spinner-border text-success"
        role="status"
        style={{ width: "3rem", height: "3rem" }}
      >
        <span className="visually-hidden">Loading...</span>
      </div>
      <p className="mt-3 mb-0 text-muted">Loading...</p>
    </div>
  </div>
);

const Layout = () => {
  const { vendorProfile } = useDataContext();
  const location = useLocation();
  const serviceType = resolveVendorServiceType(vendorProfile);

  if (!isPathAllowedForServiceType(location.pathname, serviceType)) {
    return <Navigate to={homePathForServiceType(serviceType)} replace />;
  }

  return (
    <div className="columnWrapper">
      <Sidebar />
      <div id="mainPart" className="main-content">
        <Header />
        <div className="main-content-body">
          <Suspense fallback={<PageLoadingFallback />}>
            <Outlet />
          </Suspense>
        </div>
      </div>
    </div>
  );
};

export default Layout;
